import React from 'react';

export function StatusBadge({ status }) {
  const badges = {
    live: { bg: 'bg-green-100', text: 'text-green-700', label: 'Live', icon: '✅' },
    draft: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Draft', icon: '📋' },
    archived: { bg: 'bg-gray-100', text: 'text-gray-600', label: 'Archived', icon: '📦' },
  };
  const badge = badges[status] || badges.draft;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${badge.bg} ${badge.text}`}>
      <span>{badge.icon}</span>
      <span>{badge.label}</span>
    </span>
  );
}

export function ApprovalStatusBadge({ approvalStatus }) {
  if (!approvalStatus) return null;
  
  const badges = {
    pending_approval: { bg: 'bg-yellow-100', text: 'text-yellow-700', label: 'Awaiting Approval', icon: '⏳' },
    approved: { bg: 'bg-green-100', text: 'text-green-700', label: 'Approved - Ready for Production', icon: '✅' },
  };
  const badge = badges[approvalStatus];
  if (!badge) return null;
  
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${badge.bg} ${badge.text}`}>
      <span>{badge.icon}</span>
      <span>{badge.label}</span>
    </span>
  );
}

export function WorkStatusBadge({ workStatus }) {
  if (!workStatus) return null;
  
  const badges = {
    needs_work: { bg: 'bg-orange-100', text: 'text-orange-700', label: 'In Queue', icon: '📋' },
    in_progress: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Being Worked On', icon: '🔨' },
  };
  const badge = badges[workStatus];
  if (!badge) return null;
  
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${badge.bg} ${badge.text}`}>
      <span>{badge.icon}</span>
      <span>{badge.label}</span>
    </span>
  );
}
